(() => {
  const button = document.querySelector('[data-psny-back-to-top]');
  if (!button) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const footer = document.querySelector('footer.footer');
  const updateVisibility = () => {
    button.classList.toggle('is-visible', window.scrollY > 480);
  };

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => button.classList.toggle('is-over-footer', entry.isIntersecting),
      { threshold: 0 },
    );
    footerObserver.observe(footer);
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
    });
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();
})();
